import axios from "axios";
import { getApiRoot } from '../misc/utils';

const baseURL = getApiRoot() || process.env.REACT_APP_LOCAL_API_ROOT;

const applyFilterUrl = `${baseURL}/lambda`;

const timeout = parseInt(process.env.REACT_APP_MAX_UPLOAD_TIME, 10);

var instance = axios.create({
  baseURL,
  timeout,
  headers: { "Content-Type": "application/json" }
});

function get(path, payload) {
  return instance.get(path, payload).then(r => r.data);
}

function post(path, payload) {
  return instance.post(path, payload).then(r => r.data);
}

export { get, post, baseURL, applyFilterUrl };



// WEBPACK FOOTER //
// ./src/misc/api.js